import { AvailableOption, Charge, ShoppingCart } from 'app/api/@generated/backend';

class ShoppingCartUtils {
    public static getSelectedWifiOption(shoppingCart: ShoppingCart, numberOfUnits: number): AvailableOption {
        const selectedOption = shoppingCart.wifiUnitInformation.availableOptions.find(
            (option: AvailableOption) => option.quantity === `${numberOfUnits}`,
        );

        if (!selectedOption) {
            throw new Error(`Option ${numberOfUnits} is not available`);
        }

        return selectedOption;
    }

    public static getChargeForSingleUnit(shoppingCart: ShoppingCart): Charge {
        const selectedOption = shoppingCart.wifiUnitInformation.availableOptions.find(
            (option: AvailableOption) => option.quantity === '1',
        );

        if (!selectedOption) {
            throw new Error('Could not find option for one unit');
        }

        return selectedOption.recurringCharge;
    }
}

export { ShoppingCartUtils };
